import { FORMAT_TYPES } from '@dashhudson/dashing-ui/utils/formatters';

import type { FacebookInsightDefinition } from '@/app/facebook/insights/types';

/**
 * How a metric renders, spread into its definition. A definition that declares none renders as a
 * whole-number count.
 *
 * Monetary metrics are not here: their accounting format with a trailing currency code
 * (`1,234.56 USD`) is not something any dashing-ui format type produces, so they keep the
 * `monetary` flag and are rendered by the panel.
 */
type InsightFormat = Pick<FacebookInsightDefinition, 'formatType' | 'formatOptions'>;

/** Rates carry up to two decimals; without this they would round to whole percents. */
export const PERCENT: InsightFormat = {
  formatType: FORMAT_TYPES.PERCENT,
  formatOptions: { formatOptions: { maximumFractionDigits: 2 } },
};

/** Watch times arrive in milliseconds; the formatter reads seconds by default. */
export const DURATION_MS: InsightFormat = {
  formatType: FORMAT_TYPES.DURATION,
  formatOptions: { durationOptions: { rawUnit: 'millisecond' } },
};

/** Frequency is the one count that always shows two decimals. */
export const DECIMAL: InsightFormat = {
  formatType: FORMAT_TYPES.NUMBER,
  formatOptions: { formatOptions: { minimumFractionDigits: 2, maximumFractionDigits: 2 } },
};
